module.exports = __webpack_public_path__ + "img/made_in_cambodia.4597f240.png";